import Vue from 'vue'
import Router from 'vue-router'
import HomePageComponent from '@/pages/HomePage.vue'
import OrganizationListPageComponent from '@/pages/organizations/List.vue'
import OrganizationForm from '@/pages/organizations/EditForm.vue'
import OrganizationFormAdd from '@/pages/organizations/AddForm.vue'
import MemberListPageComponent from '@/pages/members/List.vue'
import MemberFormAdd from '@/pages/members/AddForm.vue'
import MemberForm from '@/pages/members/EditForm.vue'
import DocumentListPage from '@/pages/documents/List.vue'
import DocumentFileFormAdd from '@/pages/documents/AddForm.vue'
import DocumentFileForm from '@/pages/documents/EditForm.vue'
import ForbiddenPage from '@/pages/errors/ForbiddenPage.vue'
import ViewListDocument from '@/components/view/Document/List.vue'
import ViewListOrganization from '@/components/view/Organization/List.vue'
import ViewListMember from '@/components/view/Member/List.vue'

/**
 * @typedef {import("node_modules/vue-router/types/index")} VueRouter
 */

Vue.use(Router)

/** @type {VueRouter} */
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePageComponent,
      meta: {
        requiresLogin: true
      }
    },
    {
      path: '/members/manage',
      name: 'MemberListPage',
      component: MemberListPageComponent,
      meta: {
        requiresLogin: true,
        scopes: [ 'members' ]
      }
    },
    {
      path: '/members/manage/form/add',
      name: 'MemberFormAddPage',
      component: MemberFormAdd,
      meta: {
        requiresLogin: true,
        scopes: [ 'members' ]
      }
    },
    {
      path: '/members/manage/:memberId/form/edit',
      name: 'MemberFormEditPage',
      component: MemberForm,
      meta: {
        requiresLogin: true,
        scopes: [ 'members' ]
      }
    },
    {
      path: '/organizations/manage',
      name: 'OrganizationListPage',
      component: OrganizationListPageComponent,
      meta: {
        requiresLogin: true,
        scopes: [ 'organizations' ]
      }
    },
    {
      path: '/organizations/manage/:orgId/form/edit',
      name: 'OrganizationFormEditPage',
      component: OrganizationForm,
      meta: {
        requiresLogin: true,
        scopes: [ 'organizations' ]
      }
    },
    {
      path: '/organizations/manage/form/add',
      name: 'OrganizationFormAddPage',
      component: OrganizationFormAdd,
      meta: {
        requiresLogin: true,
        scopes: [ 'organizations' ]
      }
    },
    {
      path: '/documents/manage',
      name: 'DocumentListComponent',
      component: DocumentListPage,
      meta: {
        requiresLogin: true,
        scopes: [ 'documents' ]
      }
    },
    {
      path: '/documents/manage/form/add',
      name: 'DocumentFormAddPage',
      component: DocumentFileFormAdd,
      meta: {
        requiresLogin: true,
        scopes: [ 'documents' ]
      }
    },
    {
      path: '/documents/manage/:documentId/form/edit',
      name: 'DocumentFormEditPage',
      component: DocumentFileForm,
      meta: {
        requiresLogin: true,
        scopes: [ 'documents' ]
      }
    },
    {
      path: '/403',
      name: 'ForbiddenPage',
      component: ForbiddenPage
    },
    {
      path: '/documents',
      name: 'ViewListDocument',
      component: ViewListDocument,
      meta: {
        requiresLogin: true,
        scopes: [ 'documents' ]
      }
    },
    {
      path: '/members',
      name: 'ViewListMember',
      component: ViewListMember,
      meta: {
        requiresLogin: true,
        scopes: [ 'members' ]
      }
    },
    {
      path: '/organizations',
      name: 'ViewListOrganization',
      component: ViewListOrganization,
      meta: {
        requiresLogin: true,
        scopes: [ 'organizations' ]
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js